<template>
  <section class="chronology-picker-container">
    <div class="content-wrapper">
      <div class="chronology-text-wrapper">
        <div class="chronology-text" id="700" v-if="selectedId === 700">
          <div class="age">
            <h4><br> szkíta háborúk</h4>
          </div>
          <div class="vertical-separator"></div>
          <div class="date"><h4><small>i.e.</small>700</h4></div>
        </div>

        <div class="chronology-text" id="907" v-if="selectedId === 907">
          <div class="age">
            <h4><br>pozsonyi csata</h4>
          </div>
          <div class="vertical-separator"></div>
          <div class="date"><h4>907</h4></div>
        </div>

        <div class="chronology-text" id="1217" v-if="selectedId === 1217">
          <div class="age">
            <h4><br>V. keresztes hadjárat</h4>
          </div>
          <div class="vertical-separator"></div>
          <div class="date"><h4>1217</h4></div>
        </div>

        <div class="chronology-text" id="1703" v-if="selectedId === 1703">
          <div class="age">
            <h4>Rákóczi vezette <br> szabadságharc</h4>
          </div>
          <div class="vertical-separator"></div>
          <div class="date"><h4>1703</h4></div>
        </div>

        <div class="chronology-text" id="1848" v-if="selectedId === 1848">
          <div class="age">
            <h4>forradalom és <br> szabadságharc</h4>
          </div>
          <div class="vertical-separator"></div>
          <div class="date"><h4>1848</h4></div>
        </div>

        <div class="chronology-text" id="1914" v-if="selectedId === 1914">
          <div class="age">
            <h4><br>I. világháború</h4>
          </div>
          <div class="vertical-separator"></div>
          <div class="date"><h4>1914</h4></div>
        </div>

        <div class="chronology-text" id="2017" v-if="selectedId === 2017">
          <div class="age">
            <h4 id="fokos21"><br>fokos 21</h4>
          </div>
          <div class="vertical-separator"></div>
          <div class="date"><h4>2017</h4></div>
        </div>
      </div>
      <div class="chronology-icon-wrapper" v-on:mouseleave="applyDefault()" v-on:mouseenter="removeDefault()">
        <svg v-on:mouseover="selectFokos(700)"
             xmlns="http://www.w3.org/2000/svg"
             height="349pt" preserveAspectRatio="xMidYMid meet" viewBox="0 0 213 349" width="213pt" >
          <path d="m635 3219c-96-12-159-26-373-81l-162-43v-50c0-114 59-252 145-340 82-84 84-84 138-11 87 118 195 202 329 255 83 33 194 55 253 49l40-3 1-1400c1-770 2-1444 3-1497l1-98h145 145v1500 1500h28c44 0 182-37 260-69 114-47 213-110 321-203 24-21 47-38 51-38 13 0 58 111 53 131-6 22-185 140-304 199-174 88-359 148-554 181-140 23-401 33-520 18z" transform="matrix(.1 0 0 -.1 0 349)"/>
        </svg>
        <svg v-on:mouseover="selectFokos(907)"
             xmlns="http://www.w3.org/2000/svg"
             width="169.000000pt" height="376.000000pt" viewBox="0 0 169.000000 376.000000"
             preserveAspectRatio="xMidYMid meet">
          <g transform="translate(0.000000,376.000000) scale(0.100000,-0.100000)"
             stroke="none">
            <path d="M221 3612 c-26 -48 -35 -156 -35 -407 1 -360 30 -538 141 -875 31
-95 43 -117 65 -130 26 -14 29 -13 50 7 25 26 26 15 -28 293 -23 115 -27 163
-28 325 l-1 190 35 16 c121 58 363 55 453 -5 l32 -22 3 -1502 2 -1502 125 0
125 0 0 33 c-1 17 1 693 3 1500 4 1362 5 1469 21 1485 13 14 36 17 109 17 77
0 99 -4 136 -24 63 -33 108 -31 143 8 21 23 28 42 28 71 0 75 -64 114 -160 99
-126 -21 -206 8 -263 96 l-33 50 -89 -2 c-67 -1 -109 -8 -163 -27 -166 -57
-324 -57 -442 2 l-55 27 -6 75 c-6 85 -23 124 -80 181 -42 42 -73 50 -88 21z"/>
          </g>
        </svg>
        <svg v-on:mouseover="selectFokos(1217)"
             xmlns="http://www.w3.org/2000/svg"
             width="215.000000pt" height="353.000000pt" viewBox="0 0 215.000000 353.000000"
             preserveAspectRatio="xMidYMid meet">
          <g transform="translate(0.000000,353.000000) scale(0.100000,-0.100000)"
             stroke="none">
            <path d="M169 3248 c-17 -73 -22 -122 -22 -223 0 -160 21 -245 93 -393 l51
-103 27 21 c130 98 230 166 302 203 95 50 222 93 290 98 l45 4 3 -1427 2
-1428 195 0 195 0 2 1432 3 1433 70 14 c78 15 476 21 605 9 l75 -8 -40 36
c-188 169 -421 298 -617 343 -127 29 -369 36 -548 16 -205 -24 -353 -14 -588
41 -57 13 -107 24 -112 24 -5 0 -18 -42 -31 -92z"/>
          </g>
        </svg>
        <svg v-on:mouseover="selectFokos(1703)"
             xmlns="http://www.w3.org/2000/svg"
             width="200.000000pt" height="348.000000pt" viewBox="0 0 200.000000 348.000000"
             preserveAspectRatio="xMidYMid meet">
          <g transform="translate(0.000000,348.000000) scale(0.100000,-0.100000)"
             stroke="none">
            <path d="M1020 3240 c-20 -5 -58 -19 -85 -30 -235 -103 -378 -111 -630 -34
-62 19 -116 34 -119 34 -15 0 -36 -113 -36 -198 0 -113 19 -192 68 -287 44
-84 152 -201 220 -238 l48 -26 13 75 c33 199 185 366 371 408 82 19 151 21
168 4 9 -9 12 -352 12 -1480 l0 -1468 155 0 155 0 0 1454 c0 1035 3 1462 11
1485 6 17 19 36 29 41 33 18 104 11 194 -19 49 -15 98 -26 108 -23 17 4 138
138 138 152 0 7 -111 144 -124 152 -21 15 -57 8 -116 -22 -75 -38 -118 -38
-195 0 -58 29 -63 30 -205 29 -80 -1 -161 -5 -180 -9z"/>
          </g>
        </svg>
        <svg v-on:mouseover="selectFokos(1848)"
             xmlns="http://www.w3.org/2000/svg"
             width="192.000000pt" height="362.000000pt" viewBox="0 0 192.000000 362.000000"
             preserveAspectRatio="xMidYMid meet">
          <g transform="translate(0.000000,362.000000) scale(0.100000,-0.100000)"
             stroke="none">
            <path d="M285 3381 c-65 -39 -127 -135 -152 -235 -19 -80 -10 -152 31 -242 26
-56 109 -147 159 -173 24 -13 28 -12 60 16 87 76 182 112 318 120 64 4 102 2
117 -6 l22 -12 0 -1424 0 -1425 190 0 190 0 0 1429 0 1429 26 31 c33 40 154
99 224 110 75 12 172 -3 249 -39 35 -17 66 -28 69 -25 7 7 -75 113 -128 164
-63 62 -149 116 -228 143 -65 22 -77 23 -432 23 -272 1 -376 4 -410 14 -54 16
-154 65 -196 97 -37 29 -69 30 -109 5z"/>
          </g>
        </svg>
        <svg v-on:mouseover="selectFokos(1914)"
             xmlns="http://www.w3.org/2000/svg"
             width="221.000000pt" height="375.000000pt" viewBox="0 0 221.000000 375.000000"
             preserveAspectRatio="xMidYMid meet">
          <g transform="translate(0.000000,375.000000) scale(0.100000,-0.100000)"
             stroke="none">
            <path d="M1149 3535 c-51 -28 -58 -99 -16 -158 10 -16 17 -30 15 -32 -2 -2
-220 -11 -483 -20 -264 -9 -491 -21 -504 -26 l-24 -10 6 -197 c5 -167 10 -213
32 -302 15 -58 30 -108 34 -112 3 -4 159 62 346 147 186 84 343 151 347 149 4
-3 8 -18 8 -34 0 -27 3 -29 43 -32 l42 -3 3 -1452 2 -1453 185 0 185 0 0 1440
0 1439 30 23 c31 23 50 69 50 126 0 20 6 35 16 39 8 3 149 -9 312 -26 163 -17
308 -33 322 -34 24 -2 25 0 37 93 6 52 12 109 12 125 l1 31 -442 38 c-244 21
-446 42 -450 45 -4 4 4 24 19 44 38 54 37 101 -5 138 -36 33 -80 37 -123 14z"/>
          </g>
        </svg>
        <svg v-on:mouseover="selectFokos(2017)" id="defaultIcon"
             xmlns="http://www.w3.org/2000/svg"
             width="172.000000pt" height="362.000000pt" viewBox="0 0 172.000000 362.000000"
             preserveAspectRatio="xMidYMid meet">
          <g transform="translate(0.000000,362.000000) scale(0.100000,-0.100000)" stroke="none">
            <path d="M170 3088 c0 -139 4 -258 8 -265 15 -24 136 -73 180 -73 39 0 48 5
85 46 51 56 106 83 170 84 63 0 120 -30 154 -82 l28 -42 3 -1378 2 -1378 195
0 195 0 0 1439 c0 1139 3 1441 13 1449 14 12 246 82 273 82 10 1 29 6 40 13
33 18 164 143 164 155 0 18 -138 165 -173 185 -29 16 -82 17 -684 17 l-653 0
0 -252z m720 105 c14 -6 68 -18 120 -28 111 -21 130 -29 130 -55 0 -26 -6 -29
-127 -50 -60 -11 -136 -25 -171 -31 -104 -21 -154 17 -138 104 6 33 37 70 65
79 18 5 87 -6 121 -19z"/>
          </g>
        </svg>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ChronologyPicker",
  data: function () {
    return {
      selectedId: 2017,
    }
  },
  methods: {
    selectFokos(id) {
      this.selectedId = id;
    },
    applyDefault() {
      this.selectFokos(2017);
      document.getElementById('defaultIcon').classList.add("defaultStyle")
    },
    removeDefault() {
      document.getElementById('defaultIcon').classList.remove("defaultStyle")
    }
  },
  mounted() {
    this.applyDefault()
  }
}
</script>

<style scoped>

.chronology-picker-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 20vw;
  min-height: 500px;
  background: #FFFFFF;
}

.content-wrapper {
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 100%;
  overflow: hidden;
}




/* TEXT STYLE */

.chronology-text-wrapper {
  display: flex;
  flex-direction: row;
  font-size: min(4vw, 50px);
  position: absolute;
  bottom: 60%;
}

.age {
  text-align: center;
  text-transform: uppercase;
  line-height: 1;
}

.vertical-separator {
  height: 3px;
  width: 80%;
  background: #EFBE3E;
  border-radius: 10px;
  margin: 0.3em auto 0 auto;
}

.date {
  text-align: center;
  color: #747474;
}

.date h4 {
  font-weight: 900;
}

small {
  font-size: min(3vh, 30px);
}




/* ICON STYLE */

.chronology-icon-wrapper {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  position: absolute;
  bottom: 0;
  width: 100%;
  max-width: 1800px;
  height: 20vh;
  max-height: 200px;
  overflow: hidden;
  padding-left: 10vw;
  padding-right: 10vw;
}

svg {
  height: 100%;
  fill: #000000;
  transform: translateY(25%);
  transition: transform 0.3s ease-in-out, fill 0.3s ease-in-out;
}

svg:hover, svg:active {
  transform: translateY(0);
  fill: #EFBE3E;
}

.defaultStyle {
  transform: translateY(0);
  fill: #EFBE3E;
}

@media only screen and (max-width: 1200px) {
  .chronology-picker-container {
    display: none;
  }
}
</style>
